export default "__VITE_ASSET__KP0DYCSa__"